import React, { useState, useEffect, useCallback, useRef } from "react";
import ReactSlider from "react-slider";
import $ from "jquery";
import _ from "lodash";
import { getUsers, setUser } from "../../../services/adminService";
import { showSpinner, closeSpinner, modal, confirm } from "../../../js/modules/Dialogs";
import { mavBaseLocationNotFound, sessionExpired, adminSaveChangesConfirm, adminMavWillCreateStripe, adminMavCannotPreactivate, adminMavCannotReset } from "../../../config/messages";
import { defaultAvatarBase64, stripeConnectActive } from "../../../config/env";
import { defaultMessagesFilter } from "../../../config/constants";
import { addressAutoComplete } from "../../../services/geoService";
import { toScreen } from "../../../js/modules/Routing";
import AuditNotes from "../../commonUI/AuditNotes";
import { getCounties, getCities } from "../../../services/utilService";
import PropTypes from "prop-types";
import withNavigate from "../withNavigate";
import moment from "moment-timezone";
import {
  BackArrowIcon,
  BellIcon,
  BellSlashIcon,
  DiscountIcon,
  DownloadIcon,
  EditIcon,
  EmailIcon,
  GeneralVanIcon,
  GoodsIcon,
  MessageIcon,
  PublicIcon,
  UploadIcon,
  ViewInStripe,
} from "../../commonUI/Icons/SvgIcon";
import { useNavigate } from "react-router-dom";
import { Box, Drawer } from "@mui/material";
import MavEdit from "./MavEdit";
import Pagination from "../../commonUI/Pagination/Pagination";
import TopNav from "../../commonUI/TopHeader/TopHeader";

const Mav = (props) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedMav, setSelectedMav] = useState(null);

  const ref = useRef(null);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("profile");

  const [originalStatus, setOriginalStatus] = useState("");
  const [findAddressStatus, setFindAddressStatus] = useState("");
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [inputValue, setInputValue] = useState(1);

  const [page, setPage] = useState(1);
  const [mav, setMav] = useState({
    _id: "",
    short_id: "",
    notes: [],
    accountInfo: {
      username: "",
      drivingLicence: "",
      licenceCheckCode: "",
      companyName: "",
      vatNumber: "",
      wasteHandlingLicence: "",
      wasteHandlingLicenceCopy: "",
      publicLiabilityInsurance: false,
      goodsInTransitInsurance: false,
      generalVanInsurance: false,
      firstname: "",
      surname: "",
      telephone: "",
      email: "",
      avatar: "",
      terms: false,
      settings: {
        emailnotifications: false,
        holidaymode: false,
        marketingnotifications: false,
        pushnotifications: false,
      },
      baseLocation: {
        homeaddress: {
          googleValidated: "",
          placeId: "",
          formattedAddress: "",
          postCode: "",
          addressLine1: "",
          addressLine2: "",
          cityName: "",
          countyName: "",
          countryName: "",
        },
        radius: 50,
      },
    },
    earlyAdopter: "",
    hiddenFromApi: "",
    stripeAccountId: "",
    userType: "",
    status: "",
    quotes: {},
    vanMake: "",
    vanModel: "",
    vanYear: "",
    vanRegNumber: "",
    vanStickers: false,
    tshirtSize: "",
    utilitybillCopy: "",
    utilitybillCopyData: "",
    vaninsuranceCopy: "",
    vaninsuranceCopyData: "",
    wasteHandlingLicenceCopy: "",
    wasteHandlingLicenceCopyData: "",
  });

  const [addressSuggestions, setAddressSuggestions] = useState({
    homeaddress: {},
  });

  const [countiesFound, setCountiesFound] = useState([]);
  const [citiesFound, setCitiesFound] = useState([]);
  const [loaders, setLoaders] = useState({
    baseLocation: false,
    city: false,
    postCode: false,
  });
  const [showModal, setShowModal] = useState(false);
  const [jobs] = useState([
    {
      id: 1,
      from: "123 Road way, Manchester",
      to: "15 Closed lane, York",
      date: "23 Mar 2024",
      time: "15:30",
      price: "£250",
    },
    {
      id: 2,
      from: "123 Road way, Manchester",
      to: "15 Closed lane, York",
      date: "23 Mar 2024",
      time: "15:30",
      price: "£180",
    },
  ]);

  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const handleFileSelect = (event) => {
    const target = event.target;
    let stateName = target.name.replace("Picker", "");
    let dataStateName = target.name.replace("Picker", "Data");
    let file = event.target.files[0];

    if (file) {
      let fileBase64 = "";
      getBase64(file, (result) => {
        fileBase64 = result;

        setMav((prevMav) => ({
          ...prevMav,
          [stateName]: file.name,
          [dataStateName]: fileBase64,
        }));
      });
    }
  };

  const setLoader = (loaderName, flag) => {
    setLoaders((prevLoaders) => ({
      ...prevLoaders,
      [loaderName]: flag,
    }));
  };

  const updateNotes = (newNotes, theCallback) => {
    if (!_.isEqual(newNotes, mav.notes)) {
      setMav((prevMav) => ({
        ...prevMav,
        notes: newNotes,
      }));
      if (theCallback) theCallback();
    } else if (theCallback) {
      theCallback();
    }
  };

  const handleSliderChange = (value) => {
    setMav((prevMav) => ({
      ...prevMav,
      accountInfo: {
        ...prevMav.accountInfo,
        baseLocation: {
          ...prevMav.accountInfo.baseLocation,
          radius: value,
        },
      },
    }));
  };

  const discardChanges = (event) => {
    if (event) {
      event.preventDefault();
    }
    toScreen(false, props.navigate, "/mavs");
  };

  const addressAutoComplete_done = (resStatus, responseString, resJson) => {
    if (resStatus == "400" || resStatus == 400) {
      setAddressSuggestions({
        homeaddress: {},
      });
    } else if (resStatus == 200) {
      setAddressSuggestions((prev) => ({
        ...prev,
        [resJson.addressTarget]: resJson.predictions,
      }));
    }
    setLoader("baseLocation", false);
  };

  const addressAutoComplete = (event, addressTarget) => {
    setLoader("baseLocation", true);

    try {
      if (event) {
        event.preventDefault();
      }

      if (
        findAddressStatus === "" &&
        mav.accountInfo.baseLocation[addressTarget].formattedAddress !== "" &&
        addressTarget === "homeaddress"
      ) {
        setTimeout(() => {
          var theAddress = {
            addressTarget: addressTarget,
            theAddress: {
              ...mav.accountInfo.baseLocation[addressTarget],
            },
          };

          addressAutoComplete(theAddress, addressAutoComplete_done);
        }, 100);
      } else {
        setLoader("baseLocation", false);
      }
    } catch (error) {
      setLoader("baseLocation", false);
    }
  };

  const renderMyAddresses = (key, addressTarget) => {
    const address = addressSuggestions[addressTarget][key];
    return <option value={address.description} key={key} />;
  };

  const checkAddress = (event, addressTarget) => {
    event.preventDefault();

    if (
      mav.accountInfo.baseLocation.homeaddress.placeId === "" ||
      mav.accountInfo.baseLocation.homeaddress.googleValidated !== "passed"
    ) {
      setMav((prevMav) => ({
        ...prevMav,
        accountInfo: {
          ...prevMav.accountInfo,
          baseLocation: {
            ...prevMav.accountInfo.baseLocation,
            homeaddress: {
              ...prevMav.accountInfo.baseLocation.homeaddress,
              googleValidated: "",
              placeId: "",
              formattedAddress: "",
              addressGeometry: {
                coordinates: [0, 0],
                type: "Point",
              },
            },
          },
        },
      }));
      modal(mavBaseLocationNotFound);
    }
  };

  const getMav = async (event) => {
    showSpinner();

    try {
      if (event) {
        event.preventDefault();
      }

      const theUser = {
        accountInfo: {
          username: props.userDetails.accountInfo.username,
          email: props.userDetails.accountInfo.email,
        },
        user: props.mavId ?? window.location.pathname?.split("/")[2],
        userType: "mav",
      };

      const resJson = await getUsers(theUser);

      closeSpinner();

      if (resJson.theUsers && resJson.theUsers["0"]) {
        if (
          !resJson.theUsers["0"].accountInfo.baseLocation ||
          !resJson.theUsers["0"].accountInfo.baseLocation.homeaddress ||
          !resJson.theUsers["0"].accountInfo.baseLocation.homeaddress
            .formattedAddress
        ) {
          resJson.theUsers["0"].accountInfo.baseLocation = {
            homeaddress: {
              googleValidated: "",
              placeId: "",
              formattedAddress: "",
            },
          };
        }

        if (!resJson.theUsers["0"].accountInfo.baseLocation.radius) {
          resJson.theUsers["0"].accountInfo.baseLocation.radius = 50;
        }

        setOriginalStatus(resJson.theUsers["0"].status);
        setMav(resJson.theUsers["0"]);
        runMavFetchCompleted();
      } else {
        modal("MAV user details not found", "Something went wrong!", () =>
          window.history.back()
        );
      }
    } catch (error) {
      closeSpinner();
      if (error.response?.status === 401) {
        modal(sessionExpired);
        toScreen(false, props.navigate, "/logout");
      } else if (error.response?.status === 400) {
        modal(error.message);
        toScreen(false, props.navigate, "/mavs");
      } else {
        alert("Error fetching mav: " + error?.message);
      }
    }
  };

  const runMavFetchCompleted = () => {
    getCountiesData();
    getCitiesData();
  };

  const saveMav = (event) => {
    if (event) {
      event.preventDefault();
    }

    confirm(false, adminSaveChangesConfirm, "Cancel", "Save", async () => {
      showSpinner();

      try {
        var theUser = {
          accountInfo: {
            username: props.userDetails.accountInfo.username,
            email: props.userDetails.accountInfo.email,
          },
          user: {
            _id: mav._id,
            short_id: mav.short_id,
            notes: mav.notes,
            accountInfo: {
              username: mav.accountInfo.username,
              drivingLicence: mav.accountInfo.drivingLicence,
              licenceCheckCode: mav.accountInfo.licenceCheckCode,
              publicLiabilityInsurance: mav.accountInfo.publicLiabilityInsurance,
              goodsInTransitInsurance: mav.accountInfo.goodsInTransitInsurance,
              generalVanInsurance: mav.accountInfo.generalVanInsurance,
              firstname: mav.accountInfo.firstname,
              surname: mav.accountInfo.surname,
              telephone: mav.accountInfo.telephone,
              email: mav.accountInfo.email,
              baseLocation: {
                homeaddress: {
                  googleValidated:
                    mav.accountInfo.baseLocation.homeaddress.googleValidated,
                  placeId: mav.accountInfo.baseLocation.homeaddress.placeId,
                  formattedAddress:
                    mav.accountInfo.baseLocation.homeaddress.formattedAddress,
                  postCode: mav.accountInfo.baseLocation.homeaddress.postCode,
                  addressLine1:
                    mav.accountInfo.baseLocation.homeaddress.addressLine1,
                  addressLine2:
                    mav.accountInfo.baseLocation.homeaddress.addressLine2,
                  cityName: mav.accountInfo.baseLocation.homeaddress.cityName,
                  countyName: mav.accountInfo.baseLocation.homeaddress.countyName,
                },
                radius: mav.accountInfo.baseLocation.radius,
              },
              settings: {
                emailnotifications: mav.accountInfo.settings.emailnotifications,
                holidaymode: mav.accountInfo.settings.holidaymode,
                marketingnotifications:
                  mav.accountInfo.settings.marketingnotifications,
                pushnotifications: mav.accountInfo.settings.pushnotifications,
              },
            },
            earlyAdopter: mav.earlyAdopter,
            hiddenFromApi: mav.hiddenFromApi,
            userType: mav.userType,
            status: mav.status,
            vanMake: mav.vanMake,
            vanModel: mav.vanModel,
            vanYear: mav.vanYear,
            vanRegNumber: mav.vanRegNumber,
            vanStickers: mav.vanStickers,
            tshirtSize: mav.tshirtSize,
            utilitybillCopy: mav.utilitybillCopy,
            utilitybillCopyData: mav.utilitybillCopyData,
            vaninsuranceCopy: mav.vaninsuranceCopy,
            vaninsuranceCopyData: mav.vaninsuranceCopyData,
            wasteHandlingLicenceCopy: mav.wasteHandlingLicenceCopy,
            wasteHandlingLicenceCopyData: mav.wasteHandlingLicenceCopyData,
          },
        };

        theUser.user.accountInfo.companyName = mav.accountInfo.companyName;
        theUser.user.accountInfo.vatNumber = mav.accountInfo.vatNumber;
        theUser.user.accountInfo.wasteHandlingLicence =
          mav.accountInfo.wasteHandlingLicence;

        if (mav.accountInfo.avatar === "") {
          theUser.user.accountInfo.avatar = defaultAvatarBase64;
        }

        const resJson = await setUser(theUser);

        closeSpinner();

        modal(resJson?.message || "Changes successfully saved", false, () => {
          toScreen(false, props.navigate, "/mavs");
        });
      } catch (error) {
        closeSpinner();
        if (error.response?.status === 401) {
          modal(sessionExpired);
          toScreen(false, props.navigate, "/logout");
        } else if (error.response?.status === 400) {
          modal(error.message);
        } else {
          alert("Error saving mav: " + error?.message);
        }
      }
    });
  };

  const renderQuotes = (key) => {
    const quote = mav.quotes[key];

    return (
      <tr key={key}>
        {/* <td
          className={` ${quote?.status === "open" && "text-gray"} ${
            quote?.status === "complete" && "text-success"
          }
         ${quote?.status === "paid" && "text-success"} ${
            quote?.status === "closed" && "text-yellow"
          }`}
        >
          {quote?.status
            ? quote.status.charAt(0).toUpperCase() + quote.status.slice(1)
            : "N/A"}
        </td> */}
        <td>
          <span
            className={`badge ${quote?.status === "open" && "badge-success"} ${quote?.status === "complete" && "text-success"
              }
          ${quote?.status === "paid" && "text-success"} ${quote?.status === "closed" && "text-yellow"
              }`}
          >
            {quote?.status
              ? quote.status.charAt(0).toUpperCase() + quote.status.slice(1)
              : "N/A"}
          </span>
        </td>
        <td>&pound;{quote.quoteSpec?.price}</td>
        <td>{"Available to transport your items safely."}</td>

        <td>
          <span className="u-before-icon-calendar2">
            &nbsp;&nbsp;
            {moment(quote?.job?.jobSpec?.dateAndTime?.standardDate)
              ?.tz("Europe/London")
              ?.format("DD MMM YYYY")}
          </span>
          <br />
          <span className="u-before-icon-clock">
            &nbsp;&nbsp;
            {moment(quote?.job?.jobSpec?.dateAndTime?.standardDate)
              ?.tz("Europe/London")
              ?.format("hh:mm ")}
          </span>
        </td>
        <td>{quote?.job?.jobSpec?.serviceType ?? "-"}</td>
        <td>
          <div className="text-capitalize">
            &nbsp;&nbsp;
            <div>
              {quote?.job?.originAddress?.townCityName ||
                quote?.job?.originAddress?.regionName ||
                quote?.job?.originAddress?.formattedAddress}
            </div>
            <div className="text-sm text-gray-600 ">
              {quote?.job?.jobSpec?.serviceType !== "dispose" ? "→" : null}
              {quote?.job?.destinationAddress?.townCityName ||
                quote?.job?.destinationAddress?.regionName ||
                quote?.job?.destinationAddress?.formattedAddress ||
                ""}
            </div>
          </div>
        </td>

        <td>
          <span className="u-before-icon-calendar2">
            &nbsp;&nbsp;
            {moment(quote?.job?.creationDate)
              ?.tz("Europe/London")
              ?.format("DD MMM YYYY")}
          </span>
          <br />
          <span className="u-before-icon-clock">
            &nbsp;&nbsp;
            {moment(quote?.job?.creationDate)
              ?.tz("Europe/London")
              ?.format("hh:mm ")}
          </span>
        </td>
        <td>
          <div className="d-inline-flex align-items-center g-8">
            <button
              type="button"
              className="custom-btn"
              onClick={(e) =>
                toScreen(e, props.navigate, "/job/" + quote?.job?.short_id)
              }
            >
              View Job
            </button>

            <button
              type="button"
              className="custom-btn"
              onClick={(e) =>
                toScreen(e, props.navigate, "/quote/" + quote.short_id)
              }
            >
              View Quote
            </button>
          </div>
        </td>
      </tr>
    );
  };

  const getCounties_done = (resStatus, responseString, resJson) => {
    try {
      let varCountiesFound = [];

      if (resStatus == "400" || resStatus == 400) {
        varCountiesFound = [];
      } else if (resStatus == 200) {
        varCountiesFound = resJson.counties;
      }

      setCountiesFound(varCountiesFound);
    } catch (error) {
      console.log(error);
    }
  };

  const getCountiesData = (event) => {
    if (event) {
      event.preventDefault();
    }

    getCounties(getCounties_done);
  };

  const checkCounty = (event, target) => {
    if (event) {
      event.preventDefault();
    }

    if (
      mav.accountInfo.baseLocation &&
      mav.accountInfo.baseLocation.homeaddress &&
      mav.accountInfo.baseLocation.homeaddress.countyName &&
      mav.accountInfo.baseLocation.homeaddress.countyName !== ""
    ) {
      let strCountyName = mav.accountInfo.baseLocation.homeaddress.countyName;

      const matchedCounties = countiesFound.filter(function (county) {
        return county.county === strCountyName;
      });

      if (!matchedCounties || matchedCounties.length === 0) {
        setMav((prevMav) => ({
          ...prevMav,
          accountInfo: {
            ...prevMav.accountInfo,
            baseLocation: {
              ...prevMav.accountInfo.baseLocation,
              homeaddress: {
                ...prevMav.accountInfo.baseLocation.homeaddress,
                countyName: "",
              },
            },
          },
        }));
        modal("County not found ");
      } else {
        getCitiesData();
      }
    }
  };

  const countyAutoComplete = (event, stateName) => {
    if (event) {
      event.preventDefault();
    }
  };

  const renderCounties = (key) => {
    const county = countiesFound[key];
    return <option value={county.county} key={key} />;
  };

  const getCities_done = (resStatus, responseString, resJson) => {
    try {
      let varCitiesFound = [];

      if (resStatus == "400" || resStatus == 400) {
        varCitiesFound = [];
      } else if (resStatus == 200) {
        varCitiesFound = resJson.cities;
      }
      setCitiesFound(varCitiesFound);
      setLoader("city", false);
    } catch (error) {
      console.log(error);
      setLoader("city", false);
    }
  };

  const getCitiesData = () => {
    setLoader("city", true);

    if (
      mav.accountInfo.baseLocation &&
      mav.accountInfo.baseLocation.homeaddress &&
      mav.accountInfo.baseLocation.homeaddress.countyName &&
      mav.accountInfo.baseLocation.homeaddress.countyName !== ""
    ) {
      let strCountyName = mav.accountInfo.baseLocation.homeaddress.countyName;
      getCities(strCountyName, getCities_done);
    } else {
      setLoader("city", false);
    }
  };

  const checkCity = (event, target) => {
    if (event) {
      event.preventDefault();
    }

    if (
      mav.accountInfo.baseLocation &&
      mav.accountInfo.baseLocation.homeaddress &&
      mav.accountInfo.baseLocation.homeaddress.cityName &&
      mav.accountInfo.baseLocation.homeaddress.cityName !== ""
    ) {
      let strCityName = mav.accountInfo.baseLocation.homeaddress.cityName;

      const matchedCities = citiesFound.filter(function (city) {
        return city === strCityName;
      });

      if (!matchedCities || matchedCities.length === 0) {
        setMav((prevMav) => ({
          ...prevMav,
          accountInfo: {
            ...prevMav.accountInfo,
            baseLocation: {
              ...prevMav.accountInfo.baseLocation,
              homeaddress: {
                ...prevMav.accountInfo.baseLocation.homeaddress,
                cityName: "",
              },
            },
          },
        }));
        modal("City not found ");
      }
    }
  };

  const cityAutoComplete = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (citiesFound && citiesFound.length === 0) {
      getCitiesData();
    }
  };

  const renderCities = (key) => {
    const city = citiesFound[key];
    return <option value={city} key={key} />;
  };

  const handleInputChange = (event, theCallback) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    var oldValue;

    const inputChangeCallback = () => {
      if (
        stripeConnectActive &&
        name === "mav.status" &&
        value === "active" &&
        (!mav.stripeAccountId || mav.stripeAccountId === "")
      ) {
        modal(adminMavWillCreateStripe, "Stripe Account Notice");
      } else {
        if (name === "mav.status" && value === "blocked") {
          setShowModal(true);
        } else {
          if (
            name === "mav.accountInfo.baseLocation.homeaddress.formattedAddress"
          ) {
            var newPlaceId = "";
            var newGoogleValidated = "";

            _.forEach(addressSuggestions.homeaddress, (valueA, key) => {
              if (valueA.description === value) {
                newPlaceId = valueA.place_id;
                newGoogleValidated = "passed";
              }
            });

            setMav((prevMav) => ({
              ...prevMav,
              accountInfo: {
                ...prevMav.accountInfo,
                baseLocation: {
                  ...prevMav.accountInfo.baseLocation,
                  homeaddress: {
                    ...prevMav.accountInfo.baseLocation.homeaddress,
                    googleValidated: newGoogleValidated,
                    placeId: newPlaceId,
                    addressGeometry: {
                      coordinates: [0, 0],
                      type: "Point",
                    },
                  },
                },
              },
            }));
            if (theCallback) theCallback();
          } else if (theCallback) {
            theCallback();
          }
        }
      }
    };

    // Handle special case for status changes
    if (name === "mav.status") {
      // Update UI immediately when changing status
      setMav((prevMav) => ({
        ...prevMav,
        status: value,
      }));
      if (value === "active" && oldValue === "delete") {
      }
      inputChangeCallback();
      return; // Exit early since we've handled the status change
    } else if (
      name === "mav.accountInfo.settings.pushnotifications" ||
      name === "mav.accountInfo.settings.emailnotifications" ||
      name === "mav.accountInfo.settings.marketingnotifications" ||
      name === "mav.accountInfo.settings.holidaymode"
    ) {
      let splitString = name.split(".");
      let settingType = splitString[splitString.length - 1];

      setMav((prevMav) => ({
        ...prevMav,
        accountInfo: {
          ...prevMav.accountInfo,
          settings: {
            ...prevMav.accountInfo.settings,
            [settingType]: value,
          },
          baseLocation: {
            ...prevMav.accountInfo.baseLocation,
          },
        },
      }));
      inputChangeCallback();
    } else if (
      name === "mav.status" &&
      value === "preactivation" &&
      originalStatus !== "preactivation"
    ) {
      modal(adminMavCannotPreactivate);
    } else if (
      name === "mav.status" &&
      value === "resetting" &&
      originalStatus !== "resetting"
    ) {
      modal(adminMavCannotReset);
    } else if (name !== "mav.accountInfo.terms") {
      if (name.split(".").length === 1) {
        // Handle single level property updates based on what state they belong to
        if (name === "findAddressStatus") {
          setFindAddressStatus(value);
        }
        inputChangeCallback();
      } else if (name.split(".").length === 2) {
        // Handle mav.* properties
        if (name.startsWith("mav.")) {
          const prop = name.split(".")[1];
          setMav((prevMav) => ({
            ...prevMav,
            [prop]: value,
          }));
        }
        inputChangeCallback();
      } else if (name.split(".").length >= 3) {
        // Handle nested mav properties
        const nameParts = name.split(".");
        if (nameParts[0] === "mav") {
          setMav((prevMav) => {
            const newMav = { ...prevMav };
            let current = newMav;

            // Navigate to the parent of the property to be set
            for (let i = 1; i < nameParts.length - 1; i++) {
              current = current[nameParts[i]];
            }

            // Set the final property
            current[nameParts[nameParts.length - 1]] = value;

            return newMav;
          });
        }
        inputChangeCallback();
      }
    }
  };

  const deleteMavAvatar = (event) => {
    if (event) {
      event.preventDefault();
    }

    setMav((prevMav) => ({
      ...prevMav,
      accountInfo: {
        ...prevMav.accountInfo,
        avatar: "",
      },
    }));
  };

  const handleCancelBan = () => {
    setShowModal(false);
    setMav((prevMav) => ({
      ...prevMav,
      status: originalStatus,
    }));
  };

  const handleConfirmBan = () => {
    console.log("Confirm ban and Api is in Progress");
  };

  // useEffect hook to replace componentDidMount
  useEffect(() => {
    getMav();
  }, []);

  const toggleDrawer =
    (anchor, open, view = null, mav = null) =>
      (event) => {
        if (
          event.type === "keydown" &&
          (event.key === "Tab" || event.key === "Shift")
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });

        if (open) {
          setCurrentView(view);
          if (mav) {
            setSelectedMav(mav);
          } else {
            setSelectedMav(null);
          }
        }
      };

  const list = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <MavEdit
        view={currentView}
        mav={selectedMav}
        onClose={toggleDrawer(anchor, false)}
        props={props}
      />
    </Box>
  );
  return (
    <>
<TopNav title={"Driver Details"}/>
      <div className="global-body">
        <div className="global-body-container">
          <>
            <button
              className="btn-outline-light icon-with-btn"
              onClick={() => navigate("/mavs")}
            >
              <BackArrowIcon />
              Back to Drivers
            </button>
            {/* Driver Details Card*/}
            <div className="card client-card mt-16 mb-24">
              <div className="d-flex align-items-center g-24">
                <img
                  src="https://dev-node-20-api.manandvan.app/img/user/FKCVEDKYN/3.jpg"
                  alt=""
                  width={92}
                  height={92}
                  className="profile-img"
                />
                <div>
                  <h3 className="fw-semibold mb-4 text-capitalize">
                    {mav?.accountInfo?.username}
                  </h3>
                  <div className="client-details">
                    <span className="text-sm text-gray-500">
                      {mav?.accountInfo?.email}
                    </span>
                    <span className="text-sm text-gray-400">•</span>
                    <span className="text-sm text-gray-500 text-capitalize">
                      {mav?.short_id?.toUpperCase()}
                    </span>
                    <span className="text-sm text-gray-400">•</span>
                    <span
                      className={`badge text-capitalize ${mav?.status === "active"
                          ? "badge-success"
                          : mav?.status === "preactivation"
                            ? "badge-warning"
                            : mav?.status === "deleted" ||
                              mav?.status === "blocked"
                              ? "badge-danger"
                              : "badge-secondary"
                        }`}
                    >
                      {mav?.status === "preactivation"
                        ? "Pending"
                        : mav?.status}
                    </span>

                    {["right"].map((anchor) => (
                      <React.Fragment key={anchor}>
                        <button
                          className="custom-btn"
                          onClick={toggleDrawer(
                            anchor,
                            true,
                            "editprofile",
                            mav
                          )}
                        >
                          <EditIcon />
                        </button>
                        <Drawer
                          anchor={anchor}
                          open={state[anchor]}
                          onClose={toggleDrawer(anchor, false)}
                          ModalProps={{
                            BackdropProps: {
                              style: {
                                backgroundColor: "rgba(0, 0, 0, 0.1)",
                              },
                            },
                          }}
                          sx={{
                            boxShadow: "none",
                            "& .MuiDrawer-paper": { boxShadow: "none" },
                          }}
                        >
                          {list(anchor)}
                        </Drawer>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="client-rating-info">
                    <p>{mav?.ratingAsMav}</p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                    </svg>
                    <a
                      onClick={(e) => {
                        mav.totalRatings && mav.totalRatings > 0
                          ? toScreen(
                            e,
                            navigate,
                            "/mav/" + mav.short_id + "/reviews",
                            false,
                            {
                              receiverId: mav?._id,
                              receiverShortId: mav?.short_id,
                              receiverType: mav?.userType,
                              userShortId1: "admin",
                              userShortId2: mav?.short_id,
                              username2: mav?.accountInfo?.username,
                              selectedPage:
                                window.history.state.usr?.selectedPage ?? 1,
                              selectedFilter:
                                window.history.state.usr?.selectedFilter ??
                                defaultMessagesFilter,
                              previousPath:
                                window.history.state.usr?.previousPath ??
                                window.location.pathname,
                            }
                          )
                          : null;
                      }}
                      title=""
                      className="text-sm total-rating"
                    >
                      ({mav?.totalRatings}reviews)
                    </a>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center g-12 ms-auto">
                <button
                  className="btn-purple icon-with-btn"
                  onClick={() =>
                  (window.location.href =
                    "https://dashboard.stripe.com/payments/" + mav?.short_id)
                  }
                >
                  <ViewInStripe />
                  View in Stripe
                </button>

                <button
                  className="btn-outline-light icon-with-btn"
                  onClick={(e) =>
                    toScreen(e, navigate, "/message/" + mav?.short_id, false, {
                      receiverId: mav?._id,
                      receiverShortId: mav?.short_id,
                      receiverType: mav?.userType,
                      userShortId1: "admin",
                      userShortId2: mav?.short_id,
                      username2: mav?.accountInfo?.username,
                      selectedPage: window.history.state.usr?.selectedPage ?? 1,
                      selectedFilter:
                        window.history.state.usr?.selectedFilter ??
                        defaultMessagesFilter,
                      previousPath:
                        window.history.state.usr?.previousPath ??
                        window.location.pathname,
                    })
                  }
                >
                  <MessageIcon />
                  <p className="text-capitalize">
                    Message {mav?.accountInfo?.firstname}
                  </p>
                </button>
              </div>
            </div>

            <div className="card mb-24 py-16">
              <ul className="d-flex align-items-center justify-content-between">
                <li>
                  <span className="text-sm text-gray-500 d-block">
                    Total Earned
                  </span>
                  <h5 className="fw-semibold mb-0 text-lg">
                    £{mav?.totalSpent || 0}
                  </h5>
                </li>
                <li>
                  <span className="text-sm text-gray-500 d-block">Quotes</span>
                  <h5 className="fw-semibold mb-0 text-lg">
                    {mav?.totalJobs || 0}
                  </h5>
                </li>
                <li>
                  <span className="text-sm text-gray-500 d-block">Booked</span>
                  <h5 className="fw-semibold mb-0 text-lg">
                    {mav?.activeJobs || 0}
                  </h5>
                </li>
                <li>
                  <span className="text-sm text-gray-500 d-block">
                    Conversion rate
                  </span>
                  <h5 className="fw-semibold mb-0 text-lg">
                    {mav?.booked || 0}
                  </h5>
                </li>
                <li>
                  <span className="text-sm text-gray-500 d-block">
                    Active Jobs
                  </span>
                  <h5 className="fw-semibold mb-0 text-lg">
                    {mav?.cancelled || 0}
                  </h5>
                </li>
                <li>
                  <span className="text-sm text-gray-500 d-block">
                    Cancelled
                  </span>
                  <h5 className="fw-semibold mb-0 text-lg">
                    {mav?.cancelled || 0}
                  </h5>
                </li>
              </ul>
            </div>

            <section className="tabing-section">
              {/* Left Side Content */}
              <div className="tab-content">
                <div className="modal-card mb-24">
                  <div className="custom-tabs m-0">
                    <div
                      className={`tab-item ${activeTab === "profile" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("profile")}
                    >
                      Profile
                    </div>
                    <div
                      className={`tab-item ${activeTab === "address" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("address")}
                    >
                      Address
                    </div>
                    <div
                      className={`tab-item ${activeTab === "van" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("van")}
                    >
                      Van
                    </div>
                    <div
                      className={`tab-item ${activeTab === "company" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("company")}
                    >
                      Company
                    </div>
                    <div
                      className={`tab-item ${activeTab === "insurance" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("insurance")}
                    >
                      Insurance
                    </div>{" "}
                    <div
                      className={`tab-item ${activeTab === "documents" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("documents")}
                    >
                      Documents
                    </div>
                    <div
                      className={`tab-item ${activeTab === "notifications" ? "active" : ""
                        }`}
                      onClick={() => setActiveTab("notifications")}
                    >
                      Notifications
                    </div>
                  </div>
                  <div className="p-24">
                    {/* Profile Info */}
                    {activeTab === "profile" && (
                      <>
                        <div className="card-header">
                          <h5>Profile Information</h5>

                          {["right"].map((anchor) => (
                            <React.Fragment key={anchor}>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={toggleDrawer(
                                  anchor,
                                  true,
                                  "editprofile",
                                  mav
                                )}
                              >
                                <EditIcon />
                                Edit
                              </button>
                              <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                                ModalProps={{
                                  BackdropProps: {
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    },
                                  },
                                }}
                                sx={{
                                  boxShadow: "none",
                                  "& .MuiDrawer-paper": { boxShadow: "none" },
                                }}
                              >
                                {list(anchor)}
                              </Drawer>
                            </React.Fragment>
                          ))}
                        </div>
                        <div>
                          <ul className="profile-info">
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                First name
                              </span>
                              <p className="text-capitalize">
                                {mav?.accountInfo?.firstname}
                              </p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">Surname</span>
                              <p className="text-capitalize">
                                {mav?.accountInfo?.surname}
                              </p>
                            </li>
                            <li className="profile-info-item item-full">
                              <span className="profile-info-title">Username</span>
                              <p className="text-capitalize">
                                {mav?.accountInfo?.username}
                              </p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">Email</span>
                              <p className="word-wrap">{mav?.accountInfo?.email}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Telephone
                              </span>
                              <p>{mav?.accountInfo?.telephone}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Driving Licence No
                              </span>
                              <p>{mav?.accountInfo?.drivingLicence}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Licence Check Code
                              </span>
                              <p>{mav?.accountInfo?.licenceCheckCode}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Terms agreed
                              </span>
                              <p>
                                {mav?.accountInfo?.terms === true ? "Yes" : "No"}
                              </p>
                            </li>
                            <hr />
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                T-Shirt Size
                              </span>
                              <p className="text-capitalize">{mav?.tshirtSize}</p>
                            </li>{" "}
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Needs Van Stickers
                              </span>
                              <p>{mav?.vanStickers === true ? "Yes" : "No"}</p>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                    {/* Notification List */}
                    {activeTab === "address" && (
                      <>
                        <div className="card-header">
                          <h5>Address Information</h5>
                          {["right"].map((anchor) => (
                            <React.Fragment key={anchor}>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={toggleDrawer(
                                  anchor,
                                  true,
                                  "editaddress",
                                  mav
                                )}
                              >
                                <EditIcon />
                                Edit
                              </button>
                              <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                                ModalProps={{
                                  BackdropProps: {
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    },
                                  },
                                }}
                                sx={{
                                  boxShadow: "none",
                                  "& .MuiDrawer-paper": { boxShadow: "none" },
                                }}
                              >
                                {list(anchor)}
                              </Drawer>
                            </React.Fragment>
                          ))}
                        </div>
                        <div>
                          <div className="address-info">
                            <div>
                              <div className="address-info-title">
                                Base Location
                                <a
                                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                    mav?.accountInfo?.baseLocation?.homeaddress
                                      ?.postCode
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="address-info-view-map"
                                >
                                  View on Map
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path d="M15 3h6v6"></path>
                                    <path d="M10 14 21 3"></path>
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                  </svg>
                                </a>
                              </div>
                              <p className="address-description">
                                {
                                  mav?.accountInfo?.baseLocation?.homeaddress
                                    ?.formattedAddress
                                }
                              </p>
                            </div>
                            <span className="range-badge">
                              Range: {mav?.accountInfo?.baseLocation?.radius}{" "}
                              miles
                            </span>
                          </div>
                          <ul className="profile-info">
                            <li className="profile-info-item item-full">
                              <span className="profile-info-title">
                                Address Line 1
                              </span>
                              <p>
                                {
                                  mav?.accountInfo?.baseLocation?.homeaddress
                                    ?.addressLine1
                                }
                              </p>
                            </li>
                            <li className="profile-info-item item-full">
                              <span className="profile-info-title">
                                Address Line 2
                              </span>
                              <p>
                                {
                                  mav?.accountInfo?.baseLocation?.homeaddress
                                    ?.addressLine2
                                }
                              </p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">City</span>
                              <p>
                                {
                                  mav?.accountInfo?.baseLocation?.homeaddress
                                    ?.cityName
                                }
                              </p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">County</span>
                              <p>
                                {
                                  mav?.accountInfo?.baseLocation?.homeaddress
                                    ?.countyName
                                }
                              </p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">Postcode</span>
                              <p>
                                {
                                  mav?.accountInfo?.baseLocation?.homeaddress
                                    ?.postCode
                                }
                              </p>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                    {activeTab === "van" && (
                      <>
                        <div className="card-header">
                          <h5>Van Details</h5>
                          {["right"].map((anchor) => (
                            <React.Fragment key={anchor}>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={toggleDrawer(
                                  anchor,
                                  true,
                                  "editvan",
                                  mav
                                )}
                              >
                                <EditIcon />
                                Edit
                              </button>
                              <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                                ModalProps={{
                                  BackdropProps: {
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    },
                                  },
                                }}
                                sx={{
                                  boxShadow: "none",
                                  "& .MuiDrawer-paper": { boxShadow: "none" },
                                }}
                              >
                                {list(anchor)}
                              </Drawer>
                            </React.Fragment>
                          ))}
                        </div>
                        <div>
                          <ul className="profile-info">
                            <li className="profile-info-item">
                              <span className="profile-info-title">Van Make</span>
                              <p>{mav?.vanMake}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Van Model
                              </span>
                              <p>{mav?.vanModel}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">Van Year</span>
                              <p>{mav?.vanYear}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Vehicle Reg. Number
                              </span>
                              <p>{mav?.vanRegNumber}</p>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}{" "}
                    {activeTab === "company" && (
                      <>
                        <div className="card-header">
                          <h5>Company Information</h5>
                          {["right"].map((anchor) => (
                            <React.Fragment key={anchor}>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={toggleDrawer(
                                  anchor,
                                  true,
                                  "editcompany",
                                  mav
                                )}
                              >
                                <EditIcon />
                                Edit
                              </button>
                              <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                                ModalProps={{
                                  BackdropProps: {
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    },
                                  },
                                }}
                                sx={{
                                  boxShadow: "none",
                                  "& .MuiDrawer-paper": { boxShadow: "none" },
                                }}
                              >
                                {list(anchor)}
                              </Drawer>
                            </React.Fragment>
                          ))}
                        </div>
                        <div>
                          <ul className="profile-info">
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Company Name
                              </span>
                              <p>{mav?.accountInfo?.companyName}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                Company Number
                              </span>
                              <p>{mav?.accountInfo?.companyNumber || 0}</p>
                            </li>
                            <li className="profile-info-item">
                              <span className="profile-info-title">
                                VAT Number
                              </span>
                              <p>{mav?.accountInfo?.vatNumber}</p>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}{" "}
                    {activeTab === "insurance" && (
                      <>
                        <div className="card-header">
                          <h5>Insurance Status</h5>
                          {["right"].map((anchor) => (
                            <React.Fragment key={anchor}>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={toggleDrawer(
                                  anchor,
                                  true,
                                  "editinsurance",
                                  mav
                                )}
                              >
                                <EditIcon />
                                Edit
                              </button>
                              <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                                ModalProps={{
                                  BackdropProps: {
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    },
                                  },
                                }}
                                sx={{
                                  boxShadow: "none",
                                  "& .MuiDrawer-paper": { boxShadow: "none" },
                                }}
                              >
                                {list(anchor)}
                              </Drawer>
                            </React.Fragment>
                          ))}
                        </div>
                        <div>
                          <ul className="notification-list">
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <PublicIcon />
                                  <span className="text-sm">
                                    Public Liability
                                  </span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  Insurance for third-party property damage or
                                  injury
                                </p>
                              </div>
                              <label htmlFor="switch" className="switch">
                                <input
                                  id="switch"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={
                                    mav?.accountInfo?.settings
                                      .pushnotifications === true
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <GoodsIcon />
                                  <span className="text-sm">
                                    Goods in Transit
                                  </span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  Insurance for items being transported
                                </p>
                              </div>
                              <label
                                htmlFor="emailnotifications1"
                                className="switch"
                              >
                                <input
                                  id="emailnotifications1"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={
                                    mav?.accountInfo?.settings
                                      .emailnotifications === true
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <GeneralVanIcon />
                                  <span className="text-sm">
                                    General Van Insurance
                                  </span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  Standard van insurance with business use
                                </p>
                              </div>
                              <label
                                htmlFor="marketingnotifications1"
                                className="switch"
                              >
                                <input
                                  id="marketingnotifications1"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={
                                    mav?.accountInfo?.settings
                                      .marketingnotifications === true
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                    {activeTab === "documents" && (
                      <>
                        <div className="card-header">
                          <h5>Driver Documents</h5>
                        </div>
                        <div>
                          {" "}
                          <ul className="doc-list">
                            <li className="doc-list-item">
                              <div className="w-100">
                                <span className="doc-name">
                                  Utility Bill Copy
                                </span>
                                {mav?.utilitybillCopy &&
                                  mav?.utilitybillCopy != "" ? (
                                  <a href={mav?.utilitybillCopy} target="_blank">
                                    Utility Bill Copy{" "}
                                  </a>
                                ) : (
                                  <p className="doc-status">Not uploaded</p>
                                )}
                              </div>
                              <div className="doc-upload-section">
                                {!mav?.utilitybillCopy ? (
                                  <>
                                    <input
                                      id="utilitybillCopyPicker"
                                      type="file"
                                      accept="image/*, application/pdf"
                                      onChange={handleFileSelect}
                                      name="utilitybillCopyPicker"
                                      style={{ display: "none" }}
                                    />
                                    <label
                                      htmlFor="utilitybillCopyPicker"
                                      className="btn btn-outline-light icon-with-btn"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <UploadIcon />
                                      Upload
                                    </label>
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href = mav.utilitybillCopyData;
                                      link.download = mav.utilitybillCopy;
                                      link.click();
                                    }}
                                    title="Download file"
                                  >
                                    <DownloadIcon />
                                    Download
                                  </button>
                                )}
                              </div>
                            </li>
                            <li className="doc-list-item">
                              <div className="w-100">
                                <span className="doc-name">
                                  Van Insurance Copy
                                </span>
                                {mav?.vaninsuranceCopy &&
                                  mav?.vaninsuranceCopy != "" ? (
                                  <a href={mav?.vaninsuranceCopy} target="_blank">
                                    Van Insurance Copy{" "}
                                  </a>
                                ) : (
                                  <p className="doc-status">Not uploaded</p>
                                )}
                              </div>
                              <div className="doc-upload-section">
                                {!mav?.vaninsuranceCopy ? (
                                  <>
                                    <input
                                      id="vaninsuranceCopyPicker"
                                      type="file"
                                      accept="image/*, application/pdf"
                                      onChange={handleFileSelect}
                                      name="vaninsuranceCopyPicker"
                                      style={{ display: "none" }}
                                    />
                                    <label
                                      htmlFor="vaninsuranceCopyPicker"
                                      className="btn btn-outline-light icon-with-btn"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <UploadIcon />
                                      Upload
                                    </label>
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href = mav.vaninsuranceCopyData;
                                      link.download = mav.vaninsuranceCopy;
                                      link.click();
                                    }}
                                    title="Download file"
                                  >
                                    <DownloadIcon />
                                    Download
                                  </button>
                                )}
                              </div>
                            </li>
                            <li className="doc-list-item">
                              <div className="w-100">
                                <span className="doc-name">
                                  Waste/H Licence Copy
                                </span>
                                {mav?.wasteHandlingLicenceCopy &&
                                  mav?.wasteHandlingLicenceCopy != "" ? (
                                  <a
                                    href={mav?.wasteHandlingLicenceCopy}
                                    target="_blank"
                                  >
                                    Waste/H Licence Copy{" "}
                                  </a>
                                ) : (
                                  <p className="doc-status">Not uploaded</p>
                                )}
                              </div>
                              <div className="doc-upload-section">
                                {!mav?.wasteHandlingLicenceCopy ? (
                                  <>
                                    <input
                                      id="wasteHandlingLicenceCopyPicker"
                                      type="file"
                                      accept="image/*, application/pdf"
                                      onChange={handleFileSelect}
                                      name="wasteHandlingLicenceCopyPicker"
                                      style={{ display: "none" }}
                                    />
                                    <label
                                      htmlFor="wasteHandlingLicenceCopyPicker"
                                      className="btn btn-outline-light icon-with-btn"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <UploadIcon />
                                      Upload
                                    </label>
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href =
                                        mav.wasteHandlingLicenceCopyData;
                                      link.download =
                                        mav.wasteHandlingLicenceCopy;
                                      link.click();
                                    }}
                                    title="Download file"
                                  >
                                    <DownloadIcon />
                                    Download
                                  </button>
                                )}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}{" "}
                    {activeTab === "notifications" && (
                      <>
                        <div className="card-header">
                          <h5>Notifications Settings</h5>
                          {["right"].map((anchor) => (
                            <React.Fragment key={anchor}>
                              <button
                                className="btn-outline-light icon-with-btn"
                                onClick={toggleDrawer(
                                  anchor,
                                  true,
                                  "editnotifications",
                                  mav
                                )}
                              >
                                <EditIcon />
                                Edit
                              </button>
                              <Drawer
                                anchor={anchor}
                                open={state[anchor]}
                                onClose={toggleDrawer(anchor, false)}
                                ModalProps={{
                                  BackdropProps: {
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    },
                                  },
                                }}
                                sx={{
                                  boxShadow: "none",
                                  "& .MuiDrawer-paper": { boxShadow: "none" },
                                }}
                              >
                                {list(anchor)}
                              </Drawer>
                            </React.Fragment>
                          ))}
                        </div>
                        <div>
                          <ul className="notification-list">
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <BellIcon />
                                  <span className="text-sm">
                                    Push notifications
                                  </span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  User receives job alerts and updates on their
                                  devices
                                </p>
                              </div>
                              <label htmlFor="switch" className="switch">
                                <input
                                  id="switch"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={
                                    mav?.accountInfo?.settings
                                      .pushnotifications === true
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <EmailIcon />
                                  <span className="text-sm">
                                    Email notifications
                                  </span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  User receives important account updates via
                                  email
                                </p>
                              </div>
                              <label
                                htmlFor="emailnotifications1"
                                className="switch"
                              >
                                <input
                                  id="emailnotifications1"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={
                                    mav?.accountInfo?.settings
                                      .emailnotifications === true
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <DiscountIcon />
                                  <span className="text-sm">
                                    Marketing notifications
                                  </span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  User receives special offers and promotional
                                  content
                                </p>
                              </div>
                              <label
                                htmlFor="marketingnotifications1"
                                className="switch"
                              >
                                <input
                                  id="marketingnotifications1"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={
                                    mav?.accountInfo?.settings
                                      .marketingnotifications === true
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                            <li className="notification-list-item">
                              <div>
                                <div className="d-flex align-items-center g-8">
                                  <BellSlashIcon />
                                  <span className="text-sm">Holiday mode</span>
                                </div>
                                <p className="text-sm text-gray-500 mt-2">
                                  All notifications are temporarily paused for the
                                  user
                                </p>
                              </div>
                              <label htmlFor="holidaymode1" className="switch">
                                <input
                                  id="holidaymode1"
                                  type="checkbox"
                                  disabled
                                  onChange={handleInputChange}
                                  checked={mav?.accountInfo?.settings.holidaymode}
                                />
                                <span className="slider"></span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <AuditNotes
                ref={ref}
                notes={mav?.notes}
                updateNotes={updateNotes}
              />
            </section>
          </>
          <div className="table-wrap">
            <div className="title-wrap border-bottom-0">
              <h3 className="font-semibold tracking-tight text-xl ">
                Quotes submitted
              </h3>
            </div>
          </div>
          {_.size(mav?.quotes) > 0 ? (
            <>
              <div className="table-responsive">
                <table className="table clientTable">
                  <thead>
                    <tr>
                      <th>
                        <button className="p-0 cursor-default">Status</button>
                      </th>
                      <th>
                        <button className="p-0 cursor-default">
                          Total amount
                        </button>
                      </th>

                      <th>
                        <button className="p-0 cursor-default">Message</button>
                      </th>

                      <th>
                        <button className="p-0 cursor-default">
                          Quoted On
                        </button>
                      </th>
                      <th>
                        <button className="p-0 cursor-default">Job Type</button>
                      </th>
                      <th>
                        <button className="p-0 cursor-default">Location</button>
                      </th>
                      <th>
                        <button className="p-0 cursor-default">
                          Job Created
                        </button>
                      </th>

                      <th></th>
                    </tr>
                  </thead>
                  <div>
                    {/* {Object.keys(client?.jobs)?.map(renderJobs)} */}
                  </div>
                  <tbody>{Object.keys(mav.quotes).map(renderQuotes)}</tbody>
                </table>
                {/* <Pagination
                  pageSize={pageSize}
                  totalPages={totalPages}
                  page={page}
                  setPage={setPage}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  setPageSize={setPageSize}
                /> */}
              </div>
            </>
          ) : (
            <span className="text-danger mt-16">No quotes for this MAV.</span>
          )}

          {/* Ban driver Modal */}
          {/* 
            {showModal && (
              <div className="ban-modal-backdrop" onClick={() => { handleCancelBan() }}>
                <div
                  className="ban-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="ban-modal-header">
                    <h2>Confirm driver ban</h2>
                    <p>
                      This driver has the following booked jobs. Banning the driver
                      will cancel these jobs.
                    </p>

                  </div>
                  <div className="ban-modal-body">
                    {jobs?.map((job) => (
                      <div className="job-card" key={job?.id}>
                        <div className="job-details">
                          <h4>
                            {job?.from}
                            <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path opacity="0.5" d="M0.688 5.784V4.12H4.624V5.784H0.688ZM10.3845 9.272L9.2645 8.008L11.6645 5.896H5.9525V4.04H11.6645L9.2645 1.928L10.3845 0.664L14.8325 4.936V5L10.3845 9.272Z" fill="#5A5A5A" />
                            </svg>
                            {job?.to}
                          </h4>
                          <span>
                            <span className="u-before-icon-calendar">
                              &nbsp;{job?.date}
                            </span>&nbsp;&nbsp;
                            <span className="u-before-icon-clock">
                              &nbsp; {job?.time}
                            </span>&nbsp;&nbsp;
                            <span className="u-before-icon-dollor ">
                              &nbsp;{job?.price}
                            </span>

                          </span>
                        </div>
                        <button
                          type="button"
                          className="view-btn-ban"
                          onClick={(e) =>
                            toScreen(e, navigate,
                              "/job/TPEPTYV9N",)
                          }
                        >
                          View
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="ban-modal-footer">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => { handleCancelBan() }}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-danger"
                      onClick={() => handleConfirmBan()}
                    >
                      Confirm ban
                    </button>
                  </div>
                </div>
              </div>
            )} */}
        </div>
      </div>
    </>
  );
};

Mav.contextTypes = {
  router: PropTypes.object,
};

Mav.propTypes = {
  userDetails: PropTypes.object.isRequired,
  mavId: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(Mav);
